import { createContext, useContext } from 'react';
import type { FilterVariant } from '../types';

// Two contexts because they change at different levels: the variant is the
// form's, while the scope narrows a template to one field of it.
export const FilterVariantContext = createContext<FilterVariant>('modal');

// The one field a template renders when the form lays fields out one by one.
export const FilterFieldScope = createContext<string | undefined>(undefined);

/**
 * Whether the surrounding filter form is the narrow rail rather than the modal.
 * @return {boolean} True in the rail.
 */
export function useIsFilterRail(): boolean {
  return useContext(FilterVariantContext) === 'rail';
}
